import Common from "../../../Common";
import Item from "./tbr/Item";

export interface Body {
	id?: id
	name?: string
	description?: string
	pbx_destination_id: id
	items?: number[]
}

const body: Body = {
	id: 0,
	name: "",
	description: '',
	pbx_destination_id: 0,
}

export const getPbxTbrBody = (replace: Partial<typeof body> = {}) => Object.assign(JSON.parse(JSON.stringify(body)), replace)

const Tbr = class extends Common {
	item: InstanceType<typeof Item>;

	constructor(headers: ApiHeaders) {
		super(headers)
		this.item = new Item(headers);
	}

	browse = (companyId: id) =>
		this.get(`/company/${companyId}/pbx/tbr`);

	read = (companyId: id, id: id): CustomResponse<PbxTbr> =>
		this.get(`/company/${companyId}/pbx/tbr/${id}`);

	create = (companyId: id, data: Body, options?: DadExtraOptions) =>
		this.post(`/company/${companyId}/pbx/tbr${options?.skipRedraw ? '?skipRedraw=1' : ''}`, data);

	update = (companyId: id, id: id, data: Body, options?: DadExtraOptions) =>
		this.patch(`/company/${companyId}/pbx/tbr/${id}${options?.skipRedraw ? '?skipRedraw=1' : ''}`, data);

	delete = (companyId: id, id: id) =>
		this.doDelete(`/company/${companyId}/pbx/tbr/${id}`);
}

export default Tbr
